<template>
  <div>
    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col w-3/4 mb-base">
        <vx-card title="">
          <div>
            <b-row>
              <b-col>
                <v-select
                  :value="selected"
                  v-model="selected"
                  @input="ps"
                  :options="options"
                ></v-select>
              </b-col>
              <b-col>
                <v-select
                  :value="selectedParti"
                  v-model="selectedParti"
                  @input="ps1"
                  :options="optionsParti"
                ></v-select>
              </b-col>
              <b-col v-if="ekYetkiler == 'serilot'" cols="1">
                <vs-switch style="border-radius: 20px" v-model="seriBarkodDurum" />
              </b-col>
              <b-col v-if="seriBarkodDurum == false">
                <!--
                <div style="height: 20%" v-if="ekYetkiler == 'magaza'">
                  <input
                    id="otoBarcode"
                    ref="otoBarcode"
                    v-model="otoBarcode"
                    @keyup.enter="barkodOku(0)"
                    @focus="handleFocus(1)"
                    autocomplete="off"
                    style="
                      padding: 0px;
                      margin: 0px;
                      width: 50px;
                      position: absolute;
                      width: 290px;
                      height: 115px;
                      opacity: 0;
                    "
                  />
                  <b-row style="text-align: center; margin: 5px">
                    <b-col>
                      <Icon
                        icon="bi:upc-scan"
                        style="margin-right: 5px"
                        width="35"
                        height="35"
                      />
                    </b-col>
                    <h5 style="text-align: center" class="mt-2">
                      {{ $t(scanText) }}
                    </h5>
                  </b-row>
                </div>

              -->
                <vs-input
                  class="inputx"
                  placeholder="Barkod"
                  @keyup.enter="barkodOku(0)"
                  id="barkodM"
                  :ref="barkod"
                  v-model="barkod"
                />
              </b-col>
              <b-col v-if="ekYetkiler == 'serilot' && seriBarkodDurum == true">
                <vs-input
                  class="inputx"
                  placeholder="Seri No"
                  @keyup.enter="seriNoOkut()"
                  id="barkodSeri"
                  :ref="seriNo"
                  v-model="seriNo"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-row>
                  <div class="vx-col lg:w-6/12" style="">
                    <label>Askıdaki Ürünleri Dahil Et: </label>
                  </div>
                  <div class="vx-col lg:w-6/12" style="">
                    <vs-switch style="border-radius: 20px" v-model="askiDurumu" />
                  </div>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <div class="demo-alignment">
            <vs-button
              @click="secilenPartiUrunleri()"
              style="border-radius: 5px"
              type="gradient"
              >Seçilen Parti Ürünleri</vs-button
            >

            <vs-button
              @click="siparisSec()"
              type="gradient"
              color="danger"
              style="border-radius: 5px"
              >Sipariş Seç</vs-button
            >

            <vs-button
              @click="listeTemizle()"
              type="gradient"
              style="border-radius: 5px"
              color="success"
              >Liste Temizle</vs-button
            >

            <vs-button
              @click="
                getmasrafListe();
                popupMasrafList = true;
                masrafOrderNumberValiadate = false;
              "
              type="gradient"
              color="danger"
              style="border-radius: 5px"
              >Masraf
            </vs-button>

            <vs-button
              style="border-radius: 5px"
              type="gradient"
              color="#fc9551"
              gradient-color-secondary="rgb(255, 115, 0)"
              @click="gorevListesi()"
              >Görevler</vs-button
            >
          </div>
        </vx-card>

        <vx-card title="" style="margin-top: 10px">
          <vs-table :data="sipariseGoreUrunListesi">
            <template slot="thead">
              <vs-th>Resim</vs-th>
              <vs-th sort-key="stokkodu">Stok Kodu</vs-th>
              <vs-th sort-key="stokkodu">Barkod</vs-th>
              <vs-th>Stok Adı</vs-th>
              <vs-th>Sipariş Adeti</vs-th>
              <vs-th>Eklenen</vs-th>
              <vs-th>Durum</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td style="width: 100px">
                  <vs-button
                    v-if="subeKontrol == true"
                    color="success"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-camera"
                    @click="imageShow(data[indextr].barcode)"
                  ></vs-button>
                  <vs-button
                    v-else
                    color="success"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-camera"
                    @click="imageShow(data[indextr].merchantSku)"
                  ></vs-button>
                  <!--   <img
                    :src="'data:image.png;base64,' + imageLink"
                    style="width: 100%"
                  />-->
                </vs-td>
                <vs-td :data="data[indextr].merchantSku">
                  {{ data[indextr].merchantSku }}
                </vs-td>
                <vs-td :data="data[indextr].barcode">
                  {{ data[indextr].barcode }}
                </vs-td>
                <vs-td :data="data[indextr].stokAdi">
                  {{ data[indextr].stokAdi }}
                </vs-td>
                <vs-td :data="data[indextr].quantity">
                  {{ data[indextr].quantity }}
                </vs-td>
                <vs-td :data="data[indextr].eklenen">
                  {{ data[indextr].eklenen }}
                </vs-td>
                <vs-td :data="data[indextr].durum">
                  <div style="display: none">{{ tamamlandi }}</div>
                  <div
                    v-if="data[indextr].quantity === data[indextr].eklenen"
                    class="con-vs-chip product-order-status vs-chip-success con-color"
                    style="color: rgba(255, 255, 255, 0.9)"
                  >
                    <span class="text-chip vs-chip--text">Tamamlandı</span>
                  </div>
                  <div
                    v-else
                    class="con-vs-chip product-order-status vs-chip-warning con-color"
                    style="color: rgba(255, 255, 255, 0.9)"
                  >
                    <span
                      @click="
                        ekYetkiler == 'magaza'
                          ? ''
                          : barkodOku(data[indextr].barcode, indextr)
                      "
                      class="text-chip vs-chip--text"
                      >Tamamlandı</span
                    >
                  </div>
                </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>

      <div class="vx-col w-1/4 mb-base">
        <vx-card>
          <p class="text-grey mb-3">Sipariş Detayları</p>
          <div class="flex justify-between">
            <span class="font-semibold">Sipariş No</span>
            <span class="font-medium text-danger cursor-pointer">{{
              genelSiparisNo
            }}</span>
          </div>

          <div class="flex justify-between">
            <span class="font-semibold">Kargo</span>
            <span class="font-medium text-danger cursor-pointer">{{
              genelKargoAdi
            }}</span>
          </div>

          <div class="flex justify-between">
            <span class="font-semibold">Kargo Numarası</span>
            <span class="font-medium text-danger cursor-pointer">{{ genelKargoNo }}</span>
          </div>

          <div class="flex justify-between">
            <span class="font-semibold">Müşteri</span>
            <span class="font-medium text-danger cursor-pointer">{{ genelMusteri }}</span>
            <span v-if="hediyeMi == '1'"> (Hediye Paketi) </span>
          </div>

          <div class="flex justify-between mb-2">
            <span class="text-grey">Not</span>
            <span class="font-medium text-danger">
              {{ siparisNotu }}
            </span>
          </div>

          <div class="flex justify-between mb-2">
            <span class="text-grey">Toplam ₺</span>
            <span>{{ genelToplam }}</span>
          </div>
          <vs-divider />
          <b-form-input
            v-if="ekAlan1 == 'masrafBarkodu'"
            v-model="masrafBarkodu"
            id="masrafBarkodu"
            placeholder="Masraf Barkodu"
            @keyup.enter="addMasraf('manuel')"
            style="margin-bottom: 8px"
          />
          <div class="flex justify-between mb-2">
            <vs-button
              v-if="islemiTamamlaValidate == false"
              :disabled="validated == 1"
              id="button-with-loading"
              class="w-full vs-con-loading__container"
              @click="faturaOlustur()"
              style="height: 70px"
              >İşlemi Tamamla</vs-button
            >
            <vs-button
              v-else
              :disabled="validated == 1"
              id="button-with-loading"
              class="w-full vs-con-loading__container"
              style="height: 70px"
              >İşlemi Tamamla</vs-button
            >
          </div>
          <div class="flex justify-between mb-2">
            <vs-button
              class="w-full"
              @click="faturaCikti()"
              color="red"
              style="height: 70px"
              >Fatura Çıktısı</vs-button
            >
          </div>
          <div class="flex justify-between mb-2">
            <vs-button
              color="warning"
              :disabled="validated == 0"
              @click="askiyaAl()"
              class="w-full"
              style="height: 70px"
              >Askıya Al</vs-button
            >
          </div>
          <div class="flex justify-between mb-2">
            <vs-button
              class="w-full"
              @click="kargoDurumGuncelle()"
              color="success"
              style="height: 70px"
              >Kargo Durum Güncelle</vs-button
            >
          </div>
          <div class="flex justify-between mb-2">
            <vs-button
              class="w-full"
              @click="adresBilgileriniGuncelle()"
              color="primary"
              style="height: 70px"
              >Adres Bilgilerini Güncelle</vs-button
            >
          </div>
          <div class="flex justify-between mb-2">
            <vs-button
              class="w-full"
              @click="faturaOnizleme()"
              color="purple"
              style="height: 70px"
              >Fatura Önizleme</vs-button
            >
          </div>

          <div class="" style="display: inline" v-if="imageKontrol == false">
            <img :src="'data:image.png;base64,' + imageLink" style="width: 100%" />
          </div>
          <div class="" style="display: inline" v-else>
            <img :src="imageLink" style="width: 100%" />
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-col w-3/4 mb-base"></div>
    <!-- masraf-->

    <div class="vx-row">
      <div class="vx-col w-1/4 mb-base">
        <vx-card title=""></vx-card>
      </div>
    </div>

    <vs-popup
      class="holamundo"
      title="Masraf"
      :active.sync="popupMasrafList"
      @close="masrafPopupControl()"
    >
      <b-row>
        <b-col>
          <b-row>
            <div id="printMe2">
              <div>
                <b-row>
                  <b-row style="margin-top: 8px">
                    <b-col cols="3" align-self="center">
                      <b-form-group label="Sipariş No" label-for="orderNumber">
                      </b-form-group>
                    </b-col>
                    <b-col cols="2">
                      <b-form-input
                        size="sm"
                        id="h-orderNumber"
                        v-model="orderNumberMasraf"
                        name="orderNumber"
                        v-if="masrafOrderNumberValiadate == false"
                      />
                      <b-form-input
                        size="sm"
                        id="h-orderNumber"
                        v-model="orderNumberMasraf"
                        name="orderNumber"
                        v-else
                        disabled
                      />
                    </b-col>
                    <b-col cols="3" align-self="center">
                      <b-form-group label="Stok Adı" label-for="stokAdi"> </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-input
                        size="sm"
                        id="h-cargoTrackingNumber"
                        v-model="stokAdiMasraf"
                        name="cargoTrackingNumber"
                      />
                    </b-col>
                  </b-row>
                  <b-row style="margin-top: 8px">
                    <b-col cols="3" align-self="center">
                      <b-form-group label="Adet" label-for="adet"> </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-input
                        size="sm"
                        id="h-shipFullName"
                        v-model="adetMasraf"
                        name="orderNumber"
                      />
                    </b-col>
                  </b-row>
                  <b-row style="margin-top: 10px">
                    <b-col cols="3" align-self="center">
                      <b-form-group label="Stok Kodu" label-for="stokKodu">
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-input
                        size="sm"
                        id="h-shipDistrict"
                        v-model="stokKoduMasraf"
                        name="shipDistrict"
                      />
                    </b-col>
                  </b-row>
                  <b-row style="margin-top: 10px"> </b-row>
                </b-row>
                <div slot="footer">
                  <vs-row vs-justify="flex-end">
                    <b-button
                      style="background-color: #28c76f; border-color: #28c76f"
                      @click="addMasraf"
                    >
                      <Icon
                        style="margin-right: 5px"
                        icon="mdi:content-save-check-outline"
                        width="20"
                        height="20"
                        v-b-tooltip.hover.bottom="' Masraf Kaydet'"
                      />
                      Kaydet
                    </b-button>
                  </vs-row>
                </div>
              </div>

              <b-col cols="14">
                <div class="ag-grid-container">
                  <ag-grid-vue
                    style="width: 100%; height: 300px"
                    class="ag-theme-alpine"
                    :defaultColDef="defaultColDef"
                    :columnDefs="columnDefsMasraf"
                    :rowData="masrafListe"
                    :localeText="localeText"
                    :suppressCopyRowsToClipboard="true"
                    :rowSelection="rowSelection"
                    @rowClicked="onSelectionChangedMasraf"
                    @grid-ready="onGridReady"
                    @first-data-rendered="onFirstDataRendered"
                  >
                  </ag-grid-vue>
                </div>
              </b-col>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </vs-popup>

    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->

      <div class="vx-col w-3/4 mb-base"></div>

      <div class="vx-col w-1/4 mb-base">
        <vx-card title=""> </vx-card>
      </div>
    </div>
    <vs-popup
      fullscreen
      class="holamundo"
      title="Görev Listesi"
      :active.sync="popupGorevList"
    >
      <b-row>
        <b-col>
          <b-row>
            <div id="printMe2">
              <vs-table :data="gorevliste">
                <template slot="thead">
                  <vs-th sort-key="orderNumber">Sipariş No</vs-th>
                  <vs-th sort-key="invoiceFirstName">Müşteri Ad Soyad</vs-th>
                  <vs-th sort-key="cargoTrackingNumber">Kargo No</vs-th>
                  <vs-th sort-key="cargoTrackingNumber">Pazaryeri</vs-th>
                  <vs-th>Tutar</vs-th>
                  <vs-th>Seç</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].orderNumber">
                      {{ data[indextr].orderNumber }}
                    </vs-td>
                    <vs-td :data="data[indextr].invoiceFirstName">
                      {{ data[indextr].invoiceFirstName }}
                      {{ data[indextr].invoiceLastName }}
                    </vs-td>
                    <vs-td :data="data[indextr].cargoTrackingNumber">
                      {{ data[indextr].cargoTrackingNumber }}
                    </vs-td>
                    <vs-td :data="data[indextr].pazaryeri">
                      {{ data[indextr].pazaryeri }}
                    </vs-td>
                    <vs-td :data="data[indextr].grossAmount">
                      {{ data[indextr].grossAmount }}
                    </vs-td>
                    <vs-td>
                      <span v-if="data[indextr].islem == '0'">
                        <vs-button
                          @click="
                            siparisHazirla(
                              data[indextr].orderNumber,
                              data[indextr].merchantSku,
                              data[indextr].partiNo
                            );
                            isSelectButtonClicked = true;
                          "
                          color="success"
                          type="gradient"
                          style="border-radius: 5px"
                          icon="done"
                          >Seç</vs-button
                        >
                      </span>
                      <span v-if="data[indextr].islem == '1'">
                        <vs-button
                          @click="
                            tekrarIslemeAl(
                              data[indextr].orderNumber,
                              data[indextr].merchantSku,
                              data[indextr].partiNo
                            )
                          "
                          type="gradient"
                          color="#fc9551"
                          gradient-color-secondary="rgb(255, 115, 0)"
                          style="border-radius: 5px"
                          icon="cached"
                          >Tekrar İşleme Al</vs-button
                        >
                      </span>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </b-row>
        </b-col>
      </b-row>
      <HomeSiparisDetay ref="siparisCek" />
    </vs-popup>

    <vs-popup
      fullscreen
      class="holamundo"
      title="Seçilen Parti Ürünleri"
      :active.sync="popupActive"
    >
      <table>
        <tr>
          <td>
            <vs-button @click="print()" color="success" type="filled">Çıktı Al</vs-button>
          </td>
          <td>
            <b-row style="margin-top: 5px">
              <b-col>
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <div
                    class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
                  >
                    <span class="mr-2 leading-none">İşlemler</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>

                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="excelStock('urunList', list)">
                      <span class="flex items-center">
                        <feather-icon
                          icon="TrashIcon"
                          svgClasses="h-4 w-4"
                          class="mr-2"
                        />
                        <span>İndir/Yazdır</span>
                      </span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </b-col>
            </b-row>
          </td>
        </tr>
      </table>

      <div id="printMe">
        <vs-table :data="list">
          <template slot="thead">
            <vs-th style="border: 1px solid #000000; padding: 12px" sort-key="stokkodu"
              >Resim</vs-th
            >
            <vs-th style="border: 1px solid #000000; padding: 12px" sort-key="stokkodu"
              >Raf Kodu</vs-th
            >
            <vs-th style="border: 1px solid #000000; padding: 12px" sort-key="stokkodu"
              >Sipariş Yeri</vs-th
            >
            <vs-th style="border: 1px solid #000000; padding: 12px" sort-key="stokkodu"
              >Stok Kodu</vs-th
            >
            <vs-th style="border: 1px solid #000000; padding: 12px" sort-key="stokkodu"
              >Stok Adı</vs-th
            >
            <vs-th style="border: 1px solid #000000; padding: 12px">Sipariş Adet</vs-th>
            <vs-th style="border: 1px solid #000000; padding: 12px">Depo Adet</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :key="indextr"
              v-for="(tr, indextr) in data"
              style="border: 1px solid #000000"
            >
              <vs-td style="border: 1px solid #000000">
                <img :src="data[indextr].resim" width="100" />
              </vs-td>
              <vs-td style="border: 1px solid #000000">
                {{ data[indextr].raf }}
              </vs-td>
              <vs-td style="border: 1px solid #000000">
                {{ pazaryeriVal }}- {{ partiVal }}
              </vs-td>
              <vs-td :data="data[indextr].urunKodu" style="border: 1px solid #000000">
                {{ data[indextr].urunKodu }}
              </vs-td>
              <vs-td :data="data[indextr].stokAdi" style="border: 1px solid #000000">
                {{ data[indextr].stokAdi }}
              </vs-td>
              <vs-td
                :data="data[indextr].siparisAdet"
                style="border: 1px solid #000000; text-align: center"
              >
                {{ data[indextr].siparisAdet }}
              </vs-td>
              <vs-td
                :data="data[indextr].depoAdet"
                style="border: 1px solid #000000; text-align: center"
              >
                {{ data[indextr].depoAdet }}
              </vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td style="border: 1px solid #000000; text-align: center"></vs-td>
              <vs-td style="border: 1px solid #000000; text-align: center"></vs-td>
              <vs-td style="border: 1px solid #000000; text-align: center"></vs-td>
              <vs-td style="border: 1px solid #000000; text-align: right"
                >Toplam Parça</vs-td
              >
              <vs-td style="border: 1px solid #000000; text-align: center">{{
                total
              }}</vs-td>
              <vs-td style="border: 1px solid #000000; text-align: center"></vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-popup>
    <vs-popup
      fullscreen
      class="holamundo"
      title="Seçilen Parti Ürünleri"
      :active.sync="popupActiveSiparis"
    >
      <table>
        <tr>
          <td>
            <vs-input
              class="inputx"
              placeholder="Sipariş Numarası"
              @keyup.enter="siparisBul()"
              :ref="siparisBulOrderNumber"
              v-model="siparisBulOrderNumber"
            />
          </td>
          <td>
            <b-row style="margin-top: 5px">
              <b-col>
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <div
                    class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
                  >
                    <span class="mr-2 leading-none">İşlemler</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>

                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="excelStock('siparisList', listSiparis)">
                      <span class="flex items-center">
                        <feather-icon
                          icon="TrashIcon"
                          svgClasses="h-4 w-4"
                          class="mr-2"
                        />
                        <span>İndir/Yazdır</span>
                      </span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </b-col>
            </b-row>
          </td>
        </tr>
      </table>

      <vs-table :data="listSiparis" class="mt-5">
        <template slot="thead">
          <vs-th sort-key="orderNumber">Sipariş No</vs-th>
          <vs-th sort-key="invoiceFirstName">Müşteri Ad Soyad</vs-th>
          <vs-th sort-key="cargoTrackingNumber">Kargo No</vs-th>
          <vs-th sort-key="siparisTarihi">Sipariş Tarihi</vs-th>
          <vs-th sort-key="grossAmount">Tutar</vs-th>
          <vs-th>Seç</vs-th>
          <vs-th>Sil</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data"
          :class="{'red-row': tr.mesaj && tr.mesaj.trim() !== ''}">
            <vs-td :data="data[indextr].orderNumber">
              {{ data[indextr].orderNumber }}
            </vs-td>
            <vs-td :data="data[indextr].invoiceFirstName">
              {{ data[indextr].invoiceFirstName }}
              {{ data[indextr].invoiceLastName }}
            </vs-td>
            <vs-td :data="data[indextr].cargoTrackingNumber">
              {{ data[indextr].cargoTrackingNumber }}
            </vs-td>
            <vs-td
              :data="data[indextr].siparisTarihi"
              v-if="
                data[indextr].siparisTarihi != null ||
                data[indextr].siparisTarihi != '' ||
                typeof data[indextr].siparisTarihi != 'undefined'
              "
            >
              {{ data[indextr].siparisTarihi }}
            </vs-td>
            <vs-td :data="data[indextr].grossAmount">
              {{ data[indextr].grossAmount }}
            </vs-td>
            <vs-td>
              <span v-if="data[indextr].islem == '0'">
                <vs-button
                  @click="
                    siparisHazirla(
                      data[indextr].orderNumber,
                      data[indextr].merchantSku,
                      data[indextr].partiNo
                    );
                    isSelectButtonClicked = false;
                  "
                  color="success"
                  type="gradient"
                  style="border-radius: 5px"
                  icon="done"
                  >Seç</vs-button
                >
              </span>
              <span v-if="data[indextr].islem == '1'">
                <vs-button
                  @click="
                    tekrarIslemeAl(
                      data[indextr].orderNumber,
                      data[indextr].merchantSku,
                      data[indextr].partiNo
                    );
                    isSelectButtonClicked = false;
                  "
                  type="gradient"
                  color="#fc9551"
                  gradient-color-secondary="rgb(255, 115, 0)"
                  style="border-radius: 5px"
                  icon="cached"
                  >Tekrar İşleme Al</vs-button
                >
              </span>
            </vs-td>

            <vs-td>
              <vs-button
                @click="secilenSiparisSilOnay('warning', data[indextr].orderNumber)"
                color="#f70205"
                gradient-color-secondary="#e42728"
                type="gradient"
                style="border-radius: 5px"
                icon="clear"
                >Sil</vs-button
              >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>

    <vs-popup
      fullscreen
      class="holamundo"
      title="Seçilen Parti Ürünleri"
      :active.sync="popupActiveCikti"
    >
      <vs-table :data="ciktiListesi">
        <template slot="thead">
          <vs-th sort-key="stokkodu">Parti No</vs-th>
          <vs-th sort-key="stokkodu">Stok No</vs-th>
          <vs-th sort-key="stokkodu">Stok Adı</vs-th>
          <vs-th>Depo Adet</vs-th>
          <vs-th>Sipariş Adet</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].partiNo2">
              {{ data[indextr].partiNo2 }}
            </vs-td>
            <vs-td :data="data[indextr].urunKodu">
              {{ data[indextr].urunKodu }}
            </vs-td>
            <vs-td :data="data[indextr].STOKADI">
              {{ data[indextr].STOKADI }}
            </vs-td>
            <vs-td :data="data[indextr].depoAdet">
              {{ data[indextr].depoAdet }}
            </vs-td>
            <vs-td :data="data[indextr].adet" style="font-size: 26px; color: red">
              {{ data[indextr].adet }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>

    <vs-popup
      fullscreen
      class="holamundo"
      title="Fatura Tekrar Yazdırma"
      :active.sync="popupFatura"
    >
      <b-row>
        <b-col cols="3">
          <vs-input
            class="inputx"
            placeholder="Arama"
            @keyup.enter="faturaBul()"
            :ref="faturaBulOrderNumber"
            v-model="faturaBulOrderNumber"
          />
        </b-col>
      </b-row>

      <ag-grid-vue
        style="width: 100%; height: 400px; margin-top: 25px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="listSonFaturalar"
        :localeText="localeText"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
        :rowSelection="rowSelection"
      >
      </ag-grid-vue>
    </vs-popup>
  
    <vs-popup
      class="holamundo"
      title="Adres Bilgilerini Güncelle"
      :active.sync="popupAdresGuncelle"
    >
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Şehir" label-for="adres-ship-city">
            <b-form-input
              id="adres-ship-city"
              v-model="adresShipCity"
              size="sm"
              required
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="İlçe" label-for="adres-ship-district">
            <b-form-input
              id="adres-ship-district"
              v-model="adresShipDistrict"
              size="sm"
              required
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Tam Adres" label-for="adres-ship-full">
            <b-form-textarea
              id="adres-ship-full"
              v-model="adresShipFullAddress"
              rows="4"
              required
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" class="mt-2 flex justify-end">
          <vs-button color="success" class="mr-2" @click="adresBilgileriniKaydet()">
            Güncelle
          </vs-button>
          <vs-button color="primary" @click="popupAdresGuncelle = false">
            Kapat
          </vs-button>
        </b-col>
      </b-row>
    </vs-popup>

    <vs-popup
      fullscreen
      class="holamundo"
      title="Fatura Önizleme"
      :active.sync="popupFaturaOnizleme"
    >
      <iframe
        v-if="faturaOnizlemePdfSrc"
        :src="faturaOnizlemePdfSrc"
        width="100%"
        height="800"
        frameborder="0"
      ></iframe>
    </vs-popup>

    <iframe width="560" height="315" id="ciktiPdf" src="" frameborder="0"></iframe>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
import VueBarcode from "vue-barcode";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import vSelect from "vue-select";
import state from "../../store/state";
import Store from "../../store/store";
import moment from "moment";
import HomeSiparisDetay from "../components/uzum-components/pazaryeri-components/HomeSiparisDetay.vue";
import FaturaCiktisiButon from "../components/uzum-components/pazaryeri-components/FaturaCiktisiButon.vue";
import EBelgeButon from "../components/uzum-components/pazaryeri-components/EBelgeButon.vue";
import KullaniciGorevVermeButon from "../components/uzum-components/pazaryeri-components/KullaniciGorevVermeButon.vue";
import masrafButton from "../components/uzum-components/pazaryeri-components/masrafButton.vue";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
export default {
  components: {
    Icon,
    "v-select": vSelect,
    HomeSiparisDetay,
    masrafButton,
    AgGridVue,
    FaturaCiktisiButon,
    EBelgeButon,
    KullaniciGorevVermeButon,
    "v-barcode": VueBarcode,
  },
  data() {
    return {
      otoBarcode: "",
      scanText: "Barkod okutunuz",
      masrafBarkodu: "",
      isSelectButtonClicked: false,
      masrafOrderNumberValiadate: false,
      orderNumberMasraf: "",
      islemTarihiMasraf: "",
      stokAdiMasraf: "",
      adetMasraf: "",
      stokKoduMasraf: "",
      stok: "",
      orderNumberG: "",
      ekAlan1: "",
      ekYetkiler: "",
      seriNo: "",
      tamamlandi: "",
      siparisBarkoduNumber: "",
      siparisBarkodListValidate: false,
      plas: Store.state.plasiyer,
      kulkargoNo: "",
      kulkargoFirma: "",
      productDetail: [],
      kullaniciorderNote: "",
      kullaniciorderNumber: "",
      barcodeValue: "",
      popupKartDetay: false,
      listKullaniciSiparisleri: [],
      columnDefsKullanici: [],
      islemiTamamlaValidate: false,
      rowSelection: null,
      localeText: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: null,
      onSelectionChangedCargo: [],
      rowdataCargo: [],
      onSelectionChangedMasraf: [],
      columnDefsCargo: [],
      columnDefsMasraf: [],
      gorevliste: [],
      options: [],
      optionsParti: [],
      pazaryeriTum: [],
      list: [],
      listSonFaturalar: [],
      listSiparis: [],
      masrafListe: [], // Boş bir veri dizisi ile başlayın
      sipariseGoreUrunListesi: [],
      progress: 0,
      activePrompt: false,
      pazaryeriVal: "",
      partiVal: "",
      toplamParca: 0,
      selected: { id: 0, label: "Paketleme Firması" },
      selectedParti: { id: 0, label: "Parti Nolar" },
      popupActive: false,
      popupFatura: false,
      popupGorevList: false,
      popupMasrafList: false,
      popupKullaniciGorevList: false,
      popupActiveSiparis: false,
      popupActiveCikti: false,
      popupAdresGuncelle: false,
      popupFaturaOnizleme: false,
      faturaOnizlemePdfSrc: "",
      adresShipCity: "",
      adresShipDistrict: "",
      adresShipFullAddress: "",
      barkod: "",
      siparisBulOrderNumber: "",
      genelSiparisNo: "",
      genelKargoAdi: "",
      genelKargoNo: "",
      genelMusteri: "",
      hediyeMi: 0,
      siparisNotu: "",
      genelToplam: 0,
      totalPrice: 0,
      eklenenDeger: "",
      indext: 0,
      indext1: 0,
      urunResim: "",
      validated: 1,
      validatedF: 1,
      siparisToplamParca: 0,
      eklenenToplamParca: 0,
      askiDurumu: false,
      seriBarkodDurum: false,
      aski: 0,
      imageLink: "",
      ciktiListesi: [],
      jsonD: "",
      dr: "",
      popupActiveFaturaCikti: false,
      receiptId: 0,
      faturaNo: "",
      ilkOkuma: 0,
      recId: 0,
      total: 0,
      faturaAranan: "",
      faturaBulOrderNumber: "",
      im: 0,
      secilenStok: "",

      gorevlistKontrol: false,
      subeDegeri: "",
      subeKontrol: false,
      imageKontrol: false,
      colorAlert: "danger",
      silinenSiparis: "",
      currentFocusedInput: null,
      firstInputFocused: false,
    };
  },

  created() {
    this.currentFocusedInput = 1;
    this.handleFocus(1);
    setTimeout(() => {
      document.getElementById("otoBarcode").focus();
    }, 1000);
    this.rowSelection = "single";
    this.ekYetkiler = Store.state.ekYetkiler;
    this.ekAlan1 = Store.state.ekAlan1;
    this.subeDegeri = Store.state.sube;
    if (this.subeDegeri != "") {
      this.subeKontrol = true;
    }
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
  },
  mounted() {
    this.$root.$on("masrafSil", (id) => {
      this.masrafSil(id);
    });
  },
  beforeDestroy() {
    this.$root.$off("masrafSil");
  },
  methods: {
    keepFocus() {
      this.$nextTick(() => {
        if (this.currentFocusedInput === 1) {
          this.$refs.otoBarcode.focus();
        }
      });
    },
    handleFocus(inputNumber) {
      if (inputNumber === 1 && !this.firstInputFocused) {
        this.currentFocusedInput = 1;
        this.firstInputFocused = true;
      } else if (inputNumber === this.currentFocusedInput) {
        return;
      } else if (inputNumber !== 1) {
        this.currentFocusedInput = inputNumber;
      }
      this.keepFocus();
    },
    excelStock(baslik, dataLc) {
      const data = dataLc;

      const worksheet = XLSX.utils.json_to_sheet(data);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      // Excel dosyasını kaydetme
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      let today = this.parseDate(new Date());

      saveAs(blob, baslik + today + ".xlsx");
    },
    masrafPopupControl() {
      let masrafListLenght = 0;
      if (this.masrafListe != null) masrafListLenght = this.masrafListe.length;
      //   if (masrafListLenght >= 1) {
      this.popupMasrafList = false;
      this.orderNumberMasraf = "";
      this.islemTarihiMasraf = "";
      this.stokAdiMasraf = "";
      this.adetMasraf = "";
      this.stokKoduMasraf = "";
      this.faturaolusturControl();
      /*   } else {
           this.popupMasrafList = true;
         }*/
    },

    addMasraf(manuel) {
      if (this.orderNumberMasraf !== "") {
        let args = {
          orderNumber: this.orderNumberMasraf,
          stokAdi: this.stokAdiMasraf,
          stokKodu: this.stokKoduMasraf,
          adet: this.adetMasraf,
          islemTarihi: this.islemTarihiMasraf,
        };
        if (manuel == "manuel") {
          args = {
            orderNumber: this.orderNumberMasraf,
            stokKodu: this.masrafBarkodu,
          };
        }

        const vm = this;
        const vs = this.$vs;
        const soap = require("soap");
        const url = state.sistemAddress;

        soap.createClient(url, function (err, client) {
          if (err) return console.error("SOAP Client error:", err);

          const kontrolArgs = { barkod: vm.masrafBarkodu };
          client.masrafKontrol(kontrolArgs, function (err, kontrolResult) {
            if (err) return console.error("masrafKontrol error:", err);

            if (kontrolResult.masrafKontrolResult === "Ok") {
              client.masrafEkle(args, function (err, result) {
                if (result.masrafEkleResult == "-1") {
                  Store.dispatch("logout");
                }

                vm.veriler = JSON.parse(result.masrafEkleResult);
                vm.masrafEkle = vm.veriler.jsonData;
                vm.gridData = vm.veriler.jsonData;
                if (vm.ekAlan1 == "masrafBarkodu") vm.validated = 0;
                vs.notify({
                  title: "Masraf Bilgisi",
                  text: "Masraf eklendi.",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
                vm.getmasrafListe();
              });

            } else {
              vm.masrafBarkodu = "";
              vs.notify({
                title: "Masraf Bilgisi",
                text: "Masraf eklenmedi. Kontrol sonucu: NO",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center",
              });
            }
          });
        });
      }
    },

    masrafSil(id) {
      var vm = this;
      const vs = this.$vs;
      if (vm.masrafListe.length <= 1) {
        vs.notify({
          title: "Masraf Bilgisi",
          text: "En az bir masraf bırakmalısınız.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
        return;
      } else {
        const soap = require("soap");
        const url = state.sistemAddress;
        const args = {
          id: id,
        };

        // Sunucudan veriyi sil
        soap.createClient(url, function (err, client) {
          client.masrafSil(args, function (error, result) {
            if (error) {
              console.error("Silme işlemi sırasında hata oluştu:", error);
              return;
            }
            // Kök bileşene bir olay emit et
            vm.getmasrafListe();
          });
        });
      }
    },
    getmasrafListe() {
      const vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        orderNumber: vm.genelSiparisNo,
      };
      soap.createClient(url, function (err, client) {
        if (err) {
          console.error("SOAP client oluşturulurken hata oluştu:", err);
          return;
        }

        client.masrafListe(args, function (err, result) {
          if (err) {
            console.error("Masraf listesi alınırken hata oluştu:", err);
            return;
          }

          if (result.masrafListeResult == "-1") {
            Store.dispatch("logout");
          }
          vm.veriler = JSON.parse(result.masrafListeResult);
          vm.masrafListe = vm.veriler.jsonData;
        });
      });
    },

    seriNoOkut() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        LOTNO: vm.seriNo,
        pazaryeri: vm.pazaryeriVal.trim(),
      };
      soap.createClient(url, function (err, client) {
        client.FINDSTOCKLOT(args, function (err, result) {
          if (result.FINDSTOCKLOTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.FINDSTOCKLOTResult);
          vm.barkod = vm.veriler[0].BARCODE.trim();

          vm.barkodOku(0);
        });
      });
    },
    seriNoKaydet(ISLEM, STOCKID) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        LOTNO: vm.seriNo,
        ORDERNUMBER: vm.orderNumberG,
        STOCKID: STOCKID,
        ISLEM: ISLEM,
      }; /*
      soap.createClient(url, function (err, client) {
        client.ADDSTOCKLOT(args, function (err, result) {
          if (result.ADDSTOCKLOTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.ADDSTOCKLOTResult);
        });
      });*/
    },

    kargoDurumGuncelle() {
      var vs = this.$vs;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.pazaryeriVal.trim() == "") {
        vs.notify({
          title: "Kargo Durumu",
          text: "Pazaryeri bilgisi eksik",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center",
        });
      } else if (vm.genelSiparisNo == "") {
        vs.notify({
          title: "Kargo Durumu",
          text: "Sipariş bilgisi eksik",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center",
        });
      } else {
        const args = {
          token: Store.state.tokenId,
          pazarYeri: vm.pazaryeriVal.trim(),
          orderNumber: vm.genelSiparisNo,
          sipDurum: "6",
        };
        soap.createClient(url, function (err, client) {
          client.siparisDurumGuncelle(args, function (err, result) {
            if (result.siparisDurumGuncelleResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vm.veriler = JSON.parse(result.siparisDurumGuncelleResult);
            vs.notify({
              title: "Sipariş Silindi",
              text: "Sipariş Silindi",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          });
        });
        }
      },
      adresBilgileriniGuncelle() {
        var vs = this.$vs;
        var vm = this;
        const soap = require("soap");
        const url = state.sistemAddress;
        
        if (vm.pazaryeriVal.trim() == "") {
          vs.notify({
            title: "Adres Bilgileri",
            text: "Pazaryeri bilgisi eksik",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
          return;
        }
        if (vm.genelSiparisNo == "") {
          vs.notify({
            title: "Adres Bilgileri",
            text: "Sipariş bilgisi eksik",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
          return;
        }
        const args = {
          program: vm.pazaryeriVal.trim(),
          orderNumber: vm.genelSiparisNo,
          token: Store.state.tokenId,
        };
        try {
          soap.createClient(url, function (err, client) {
            client.SiparisAdresBilgileriGetir(args, function (err, result) {
              if (result.SiparisAdresBilgileriGetirResult == "-1") {
                Store.dispatch("logout");
              }
              let data = result.SiparisAdresBilgileriGetirResult;
              if (typeof data === "string") {
                try {
                  data = JSON.parse(data);
                } catch (e) {
                  data = null;
                }
              }
              if (data) {
                vm.adresShipCity = data.ShipCity || "";
                vm.adresShipDistrict = data.ShipDistrict || "";
                vm.adresShipFullAddress = data.ShipFullAddress || "";
                vm.popupAdresGuncelle = true;
              } else {
                vs.notify({
                  title: "Adres Bilgileri",
                  text: "Adres bilgisi bulunamadı",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                });
              }
            });
          });
      } catch (error) {
        console.log(error);
      }
    },
    faturaOnizleme() {
      var vs = this.$vs;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      if (vm.genelSiparisNo == "") {
        vs.notify({
          title: "Fatura Önizleme",
          text: "Sipariş bilgisi eksik",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
        return;
      }

      const args = {
        token: Store.state.tokenId,
        orderNumber: vm.genelSiparisNo,
      };

      try {
        soap.createClient(url, function (err, client) {
          client.BirFaturaPreview(args, function (err, result) {
            if (err) {
              vs.notify({
                title: "Fatura Önizleme",
                text: "Önizleme alınamadı",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
              return;
            }

            if (result.BirFaturaPreviewResult == "-1") {
              Store.dispatch("logout");
              return;
            }

            let preview = result.BirFaturaPreviewResult;
            vm.veriler = preview;

            if (typeof preview === "string") {
              try {
                preview = JSON.parse(preview);
              } catch (e) {
                console.log(e);
              }
            }

            const previewPdfBase64 =
              preview && typeof preview === "object"
                ? preview.previewPdfBase64 || preview.PreviewPdfBase64 || ""
                : "";

            if (previewPdfBase64) {
              vm.faturaOnizlemePdfSrc =
                "data:application/pdf;base64," + previewPdfBase64;
              vm.popupFaturaOnizleme = true;
            } else {
              vs.notify({
                title: "Fatura Önizleme",
                text: "PDF önizleme verisi bulunamadı",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center",
              });
            }
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    adresBilgileriniKaydet() {
      var vs = this.$vs;
      var vm = this;
        const soap = require("soap");
        const url = state.sistemAddress;
        
        const args = {
          program: vm.pazaryeriVal.trim(),
          orderNumber: vm.genelSiparisNo,
          shipCity: vm.adresShipCity,
          shipDistrict: vm.adresShipDistrict,
          shipFullAddress: vm.adresShipFullAddress,
          token: Store.state.tokenId,
        };
        if (
          !args.shipCity ||
          !args.shipDistrict ||
          !args.shipFullAddress ||
          args.shipCity.trim() == "" ||
          args.shipDistrict.trim() == "" ||
          args.shipFullAddress.trim() == ""
        ) {
          vs.notify({
            title: "Adres Bilgileri",
            text: "Şehir, ilçe ve tam adres alanları boş olamaz",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
          return;
        }
        try {
          soap.createClient(url, function (err, client) {
            client.SiparisAdresBilgileriGuncelle(args, function (err, result) {
              if (result.SiparisAdresBilgileriGuncelleResult == "-1") {
                Store.dispatch("logout");
              }
              vs.notify({
                title: "Adres Bilgileri",
                text: "Adres bilgileri güncellendi",
                iconPack: "feather",
                icon: "icon-check",
                color: "success",
                position: "top-center",
              });
              vm.popupAdresGuncelle = false;
            });
          });
        } catch (error) {
          console.log(error);
        }
      },
      onFirstDataRendered(params) {
        params.api.sizeColumnsToFit();
      },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      if (this.subeKontrol == true) {
        params.columnApi.setColumnVisible("magazaKodu", true);
      } else {
        params.columnApi.setColumnVisible("magazaKodu", false);
      }
    },
    EBelge(gelen) {
      window.open(gelen, "_blank");
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },

    gorevListesi() {
      this.popupGorevList = true;
      this.gorevlistKontrol = true;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        gorevyeri: Store.state.sube,
        gorev: Store.state.ekYetkiler,
      };
      soap.createClient(url, function (err, client) {
        client.magazaGorevListesi(args, function (err, result) {
          if (result.magazaGorevListesiResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.magazaGorevListesiResult);
          vm.gorevliste = vm.veriler.jsonData;
        });
      });
    },
    secilenSiparisSilOnay(color, gelenOrder) {
      this.silinenSiparis = gelenOrder;
      this.$vs.dialog({
        color: color,
        title: "Uyarı", //`Dialog - ${this.colorAlert}`,
        text: "Sipariş siliniyor emin misiniz ?",
        acceptText: "Sil",
        accept: this.secilenSiparisSil,
      });
    },
    secilenSiparisSil(gelen) {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.pazaryeriVal)
      const args = {
        pazaryeri: this.pazaryeriVal.trim(),
        orderNumber: vm.silinenSiparis,
        token: Store.state.tokenId,
      };

      soap.createClient(url, function (err, client) {
        client.secilenSiparisSil(args, function (err, result) {
          if (result.siparisListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = JSON.parse(result.secilenSiparisSilResult);

            if (vm.veriler.response == "Ok") {
              vs.loading.close("#button-with-loading-partile > .con-vs-loading");
              vs.notify({
                title: "Sipariş Silindi",
                text: "Sipariş Silindi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            } else {
              vs.notify({
                title: "Sipariş Silinemedi",
                text: "Sipariş Silmede Hata Oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "error",
                position: "top-center",
              });
            }
          }
        });
      });
    },
    faturaolusturControl() {
      if (this.ekAlan1 === "hediyeMi") {
        if (this.genelSiparisNo != "")
          if (this.isSelectButtonClicked == true) {
            if (this.genelToplam > 500) {
              let masrafListLenght = 0;
              if (this.masrafListe != null) masrafListLenght = this.masrafListe.length;
              if (masrafListLenght >= 1) {
                this.validated = 0;
              } else {
                this.popupMasrafList = true;

                this.orderNumberMasraf = this.genelSiparisNo;
                this.masrafOrderNumberValiadate = true;
              }
            } else {
              this.validated = 0;
            }
          } else this.validated = 0;
      } else {
        this.validated = 0;
      }
    },
    faturaOlustur() {
      var vm = this;
      var vs = this.$vs;
      
      try {
        const soap = require("soap");
        const url = state.sistemAddress;

        // fatura yazma işlemini ayrı bir fonksiyon içine aldık, böylece kargo bittiğinde burayı çağıracağız
        function faturaIsleminiBaslat() {
          vm.islemiTamamlaValidate = true;
          vs.loading({
            background: vm.backgroundLoading,
            color: vm.colorLoading,
            container: "#button-with-loading",
            scale: 0.45,
          });

          // alert(vm.pazaryeriVal)
          if (vm.recId == null) {
            vm.recId = 1;
          }
          // alert(vm.genelSiparisNo+" - "+this.pazaryeriVal.trim()+" - "+Store.state.grupKod+" - "+Store.state.tokenId+" - "+vm.recId+" - "+Store.state.plasiyer)
          var args = {
            orderNumber: vm.genelSiparisNo,
            program: vm.pazaryeriVal.trim(),
            grupKod: Store.state.grupKod,
            token: Store.state.tokenId,
            recId: vm.recId,
            EMPLOYEEID: Store.state.plasiyer,
          };
          if (vm.gorevlistKontrol == true) {
            args = {
              orderNumber: vm.genelSiparisNo,
              program: vm.pazaryeriVal.trim(),
              grupKod: Store.state.grupKod,
              token: Store.state.tokenId,
              recId: "0",
              EMPLOYEEID: Store.state.plasiyer,
            };
          }
          /*  const args1 = {orderNumber:vm.genelSiparisNo,program: this.pazaryeriVal.trim(),grupKod:Store.state.grupKod,token:Store.state.tokenId,recId:546610}
          const args2 = {orderNumber:vm.genelSiparisNo,program: this.pazaryeriVal.trim(),grupKod:Store.state.grupKod,token:Store.state.tokenId,recId:546622}
          const args3 = {orderNumber:vm.genelSiparisNo,program: this.pazaryeriVal.trim(),grupKod:Store.state.grupKod,token:Store.state.tokenId,recId:546621}
          const args4 = {orderNumber:vm.genelSiparisNo,program: this.pazaryeriVal.trim(),grupKod:Store.state.grupKod,token:Store.state.tokenId,recId:546620}
          const args5 = {orderNumber:vm.genelSiparisNo,program: this.pazaryeriVal.trim(),grupKod:Store.state.grupKod,token:Store.state.tokenId,recId:546619}*/

          soap.createClient(url, function (err, client) {
            client.faturaYaz(args, function (err, result) {
              if (result.faturaYazResult == "-1") {
                Store.dispatch("logout");
                //this.$store.dispatch('login', payload)
              } else {
                /*  if(vm.gorevlistKontrol == false){

                }
                else*/
                try {
                  const faturaYazResultText = String(result.faturaYazResult || "");
                  let faturaYazResult;

                  try {
                    faturaYazResult = JSON.parse(faturaYazResultText);
                  } catch (parseError) {
                    const messageMatch = faturaYazResultText.match(/"message":"([\s\S]*)"\s*}$/);
                    faturaYazResult = {
                      response: "No",
                      error: "Yes",
                      message: messageMatch ? messageMatch[1] : faturaYazResultText,
                    };
                  }

                  console.log(faturaYazResult.message);

                  if (vm.recId == 0) {
                    vs.loading.close("#button-with-loading > .con-vs-loading");
                    vm.veriler = faturaYazResult;
                    vs.notify({
                      title: "Fatura",
                      text: faturaYazResult.message,
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "warning",
                      position: "top-center",
                      fixed: true,
                    });
                    vm.validatedF = 0;
                    vm.validated = 1;
                  } else {
                    vm.veriler = faturaYazResult;
                    if (vm.veriler.response == "Ok") {
                      vs.loading.close("#button-with-loading > .con-vs-loading");
                      vm.validatedF = 0;
                      vm.recId = 0;
                      vm.masrafBarkodu = "";
                      vm.receiptId = vm.veriler.ReceiptId;
                      vm.faturaNo = vm.veriler.FaturaNo;
                      vs.loading.close("#button-with-loading-partile > .con-vs-loading");
                      vs.notify({
                        title: "Fatura",
                        text: "Fatura İşlemi Başarılı",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success",
                        position: "top-center",
                      });
                      if (
                        Store.state.printAddress != "" ||
                        typeof Store.state.printAddress != undefined ||
                        Store.state.printAddress != null
                      )
                        document.getElementById("ciktiPdf").src =
                          Store.state.printAddress +
                          vm.receiptId.replace("'", "") +
                          "&Tr=" +
                          vm.pazaryeriVal;
                      vm.imageLink = "";
                      //  window.open(Store.state.printAddress+vm.receiptId.replace("'",""), "_blank");
                      if (vm.seriBarkodDurum == true)
                        document.getElementById("barkodSeri").focus();
                      else document.getElementById("barkodM").focus();
                      vm.listeTemizle();
                      vm.validated = 1;
                    } else {
                      vs.loading.close("#button-with-loading > .con-vs-loading");
                      vm.validated = 1;
                      vs.notify({
                        title: "Fatura",
                        text: vm.veriler.message,
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-center",
                        fixed: true,
                      });
                    }
                  }
                } catch (error) {
                  if (error.toString().includes("focus")) {
                    vs.loading.close("#button-with-loading > .con-vs-loading");
                  } else {
                    vs.loading.close("#button-with-loading > .con-vs-loading");
                    vs.notify({
                      title: "Fatura",
                      text: "Herhangi bir cevap dönmedi" + error,
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "danger",
                      position: "top-center",
                      fixed: true,
                    });
                  }
                }
              }
            });
          });
        }

        // önce kargo kontrolü yapılır
        // if (!vm.genelKargoNo) {
        //   var argsKargo = {
        //     orderNumber: vm.genelSiparisNo,
        //     program: vm.pazaryeriVal.trim(),
        //   };
        //   soap.createClient(url, function (err, client) {
        //     client.kargoGonder(argsKargo, function (err, result) {
        //       // kargo işlemi tamamlandıktan sonra fatura işlemine geç
        //       faturaIsleminiBaslat();
        //     });
        //   });
        // } else {
          // eğer kargo işlemi yoksa direkt faturaya geç
          faturaIsleminiBaslat();
        // }

      } catch (err) {
        vs.notify({
          title: "Hata",
          text: "Kargo kontrolünde bir hata oluştu: " + err,
          color: "danger",
          position: "top-center",
        });
      }
    },
    faturaCiktiEvrak(order) {
      console.log(Store.state.printAddress + order + "&Tr=" + this.pazaryeriVal);
      document.getElementById("ciktiPdf").src =
        Store.state.printAddress + order + "&Tr=" + this.pazaryeriVal;
    },
    faturaCikti() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      var args;
      if (Store.state.sube == "")
        args = {
          token: Store.state.tokenId,
          program: this.pazaryeriVal,
          EMPLOYEEID: Store.state.plasiyer,
          faturaAranan: "",
        };
      else
        args = {
          token: Store.state.tokenId,
          program: this.pazaryeriVal,
          EMPLOYEEID: Store.state.sube,
          faturaAranan: "",
        };

      soap.createClient(url, function (err, client) {
        client.sonFaturalar(args, function (err, result) {
          if (result.sonFaturalarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = JSON.parse(result.sonFaturalarResult);
            vm.listSonFaturalar = vm.veriler;

            vm.popupFatura = true;
          }
        });
      });
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe");
    },
    indexbul(array, conditionFn) {
      let indexOfItem = -1;
      let deger = array.filter(conditionFn);
      const item = array.find(conditionFn);

      //   if(typeof item.eklenen != "undefined")  console.log(item.eklenen)
      if (deger.length > 1) {
        deger.forEach((element, index) => {
          if (
            typeof element.receteTanim == "undefined" ||
            element.receteTanim != "recete" ||
            typeof element.eklenen == "undefined" ||
            element.eklenen == 0 ||
            element.eklenen < element.quantity
          ) {
            indexOfItem = array.indexOf(element);
          }
        });

        this.sipariseGoreUrunListesi[indexOfItem].receteTanim = "recete";
      } else {
        indexOfItem = array.indexOf(item);
      }

      return indexOfItem;
    },
    ps1(text) {
      this.partiVal = this.selectedParti;
      // alert(this.partiVal)
      if (this.ekYetkiler == "magaza") {
        setTimeout(() => {
          document.getElementById("otoBarcode").focus();
        }, 50);
      }
    },
    ps(text) {
      const partiNumalari = [];
      this.pazaryeriVal = text;
      this.$store.commit("uzum/FATURA_PAZARYERIVAL", this.pazaryeriVal);
      partiNumalari.push("Tümü");
      this.pazaryeriTum.forEach((element) => {
        if (text == element.pazaryeri) {
          partiNumalari.push(element.partiNo2);
        }
      });
      this.optionsParti = partiNumalari;
      this.partiVal = this.selectedParti.label;
    },
    ciktiAl() {
      const vs = this.$vs;
      if (this.pazaryeriVal == "" || this.partiVal == "" || this.partiVal == "Tümü") {
        vs.notify({
          title: "Paketleme",
          text: "Pazaryerini ve Parti Seçiniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        var vm = this;
        const soap = require("soap");
        const url = state.sistemAddress;
        const args = {
          pazaryeri: this.pazaryeriVal,
          partiNo: this.partiVal,
          token: Store.state.tokenId,
        };
        soap.createClient(url, function (err, client) {
          client.partiYaz(args, function (err, result) {
            if (result.partiYazResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            } else {
              vm.veriler = JSON.parse(result.partiYazResult);
              vm.ciktiListesi = vm.veriler;
              vm.popupActiveCikti = true;
              vm.jsonD = vm.veriler;
            }
          });
        });
      }
    },

    secilenPartiUrunleri() {
      const vs = this.$vs;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        pazaryeri: this.pazaryeriVal,
        partiNo: this.partiVal,
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.partiUrunleri(args, function (err, result) {
          if (result.partiUrunleriResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            try {
              vm.veriler = JSON.parse(result.partiUrunleriResult);
              vm.total = vm.veriler[0]["tt"];
              vm.list = vm.veriler;
              vm.popupActive = true;
            } catch (error) {
              console.log(error);
            }
          }
        });
      });
    },
    faturaBul() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        program: this.pazaryeriVal,
        EMPLOYEEID: Store.state.plasiyer,
        faturaAranan: vm.faturaBulOrderNumber,
      };
      soap.createClient(url, function (err, client) {
        client.sonFaturalar(args, function (err, result) {
          if (result.sonFaturalarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = JSON.parse(result.sonFaturalarResult);

            vm.listSonFaturalar = vm.veriler;

            vm.popupFatura = true;
          }
        });
      });
    },
    siparisBul() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.pazaryeriVal)
      const args = {
        pazaryeri: this.pazaryeriVal.trim(),
        token: Store.state.tokenId,
        sayfa: 0,
        orderNumber: this.siparisBulOrderNumber,
      };
      soap.createClient(url, function (err, client) {
        client.siparisListele(args, function (err, result) {
          if (result.siparisListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = JSON.parse(result.siparisListeleResult);
            vm.listSiparis = vm.veriler;
            vm.popupActiveSiparis = true;
          }
        });
      });
    },
    siparisSec() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.pazaryeriVal)
      const args = {
        pazaryeri: this.pazaryeriVal.trim(),
        token: Store.state.tokenId,
        sayfa: 0,
      };
      soap.createClient(url, function (err, client) {
        client.siparisListele(args, function (err, result) {
          if (result.siparisListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            try {
              vm.veriler = JSON.parse(result.siparisListeleResult);

              vm.popupActiveSiparis = true;
              /*  if (vm.ekYetkiler == "serilot") {
                  vm.lotKontrol();
                }*/
              vm.gorevlistKontrol = false;
              if (vm.pazaryeriVal.trim() == "Ikas") {
                vm.listSiparis = vm.veriler.jsonData;
              } else {
                vm.listSiparis = vm.veriler;
              }
            } catch (error) {
              console.log(result);
            }
          }
        });
      });
    },
    lotKontrol() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.pazaryeriVal)
      const args = {
        token: Store.state.tokenId,
      }; /*
      soap.createClient(url, function (err, client) {
        client.OKUNANLOTKONTROL(args, function (err, result) {
          if (result.OKUNANLOTKONTROLResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            try {
              vm.veriler = JSON.parse(result.OKUNANLOTKONTROLResult);
            } catch (error) {
              console.log(result);
            }
          }
        });
      });*/
    },
    barkodOku(gelenorder, gelenindex) {
      // alert(gelenorder)
      const vm = this;
      const vs = this.$vs;
      const kontrol = 0;
      vm.islemiTamamlaValidate = false;

      if (vm.askiDurumu === true) {
        vm.aski = 1;
      } else {
        vm.aski = 0;
      }
      if (this.pazaryeriVal == "" && this.gorevlistKontrol == false) {
        vs.notify({
          title: "Paketleme",
          text: "Pazaryerini Seçiniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
        vm.kontrol = 1;
      }
      if (this.partiVal == "" && this.gorevlistKontrol == false) {
        vs.notify({
          title: "Paketleme",
          text: "Parti Seçiniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
        vm.kontrol = 1;
      }

      if (kontrol == 0 && vm.sipariseGoreUrunListesi.length == 0) {
        const soap = require("soap");
        const url = state.sistemAddress;
        //console.log(this.pazaryeriVal.trim()+"**"+this.partiVal+"**"+vm.barkod+"**"+this.aski+"**"+gelenorder+"**"+Store.state.tokenId)
        //  alert(vm.barkod)
        if (this.partiVal == "Parti Nolar") {
          this.partiVal = "Tümü";
        }
        var args = {
          pazaryeri: this.pazaryeriVal.trim(),
          partiNo: this.partiVal,
          barkod: vm.barkod,
          askiDurumu: this.aski,
          orderNumber: gelenorder,
          token: Store.state.tokenId,
        };
        if (this.gorevlistKontrol == true) {
          args = {
            pazaryeri: this.pazaryeriVal.trim(),
            partiNo: "task",
            barkod: "",
            askiDurumu: this.aski,
            orderNumber: gelenorder,
            token: Store.state.tokenId,
          };
        }
        soap.createClient(url, function (err, client) {
          client.partiUrun(args, function (err, result) {
            if (result.partiUrunResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }

            vm.veriler = JSON.parse(result.partiUrunResult);
            // const dm=[]

            /* for(vm.im=0;vm.im<vm.veriler.length;vm.im++) {
            if (vm.im==0) {
           //   alert("s")
               dm[vm.im]=vm.veriler[vm.im] 
               } else {
            let o=vm.indexbul(dm,item => item.barcode === vm.veriler[vm.im].barcode)
            //alert(o)
            if (o!=-1) {
              
              dm[o].quantity=dm[o].quantity+vm.veriler[vm.im].quantity
            } else {
              dm[vm.im]=vm.veriler[vm.im] 
            }
            }
          }*/
            // vm.veriler=dm
            if (vm.veriler.response == "No") {
              vs.notify({
                title: "Paketleme",
                text: "Okutulan Ürün Sipariş Listesinde Yok",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center",
              });
            } else {
              vm.genelSiparisNo = vm.veriler[0].orderNumber;
              vm.orderNumberMasraf = vm.genelSiparisNo;
              vm.genelKargoAdi = vm.veriler[0].cargoProviderName;
              vm.genelKargoNo = vm.veriler[0].cargoTrackingNumber;
              vm.genelToplam = vm.veriler[0].grossAmount;
              vm.totalPrice = vm.veriler[0].totalPrice;
              vm.genelMusteri =
                vm.veriler[0].shipFirstName + " " + vm.veriler[0].shipLastName;
              vm.hediyeMi = vm.veriler[0].hediyeMi;
              vm.siparisNotu = vm.veriler[0].siparisNotu;
              vm.recId = vm.veriler[0].siparisKayit;
              //  if (vm.ekAlan1 === "hediyeMi")
              vm.getmasrafListe();

              let dizi = [];
              let i = 0;
              vm.veriler.forEach((element) => {
                vm.indext = vm.indexbul(
                  dizi,
                  (item) =>
                    item.merchantSku === element.merchantSku && item.barcode === vm.barkod
                );

                if (vm.indext == -1) {
                  dizi.push({
                    barcode: element.barcode,
                    cargoProviderName: element.cargoProviderName,
                    cargoTrackingNumber: element.cargoTrackingNumber,
                    grossAmount: element.grossAmount,
                    hediyeMi: element.hediyeMi,
                    lineId: element.lineId,
                    merchantSku: element.merchantSku,
                    orderNumber: element.orderNumber,
                    quantity: element.quantity,
                    shipFirstName: element.shipFirstName,
                    shipLastName: element.shipLastName,
                    siparisKayit: element.siparisKayit,
                    stokAdi: element.stokAdi,
                  });
                  // dizi[i]['personelAdi']=element.personelAdi
                  i++;
                } else {
                  dizi[vm.indext].quantity =
                    parseInt(dizi[vm.indext].quantity) + element.quantity;
                }
              });

              vm.sipariseGoreUrunListesi = dizi;

              vm.indext = vm.indexbul(
                vm.sipariseGoreUrunListesi,
                (item) => item.barcode === vm.barkod
              );

              if (vm.indext == -1) {
                vm.indext = vm.indexbul(
                  vm.sipariseGoreUrunListesi,
                  (item) => item.merchantSku === vm.barkod
                );
              }

              if (vm.gorevlistKontrol == false) {
                vm.imageShow(vm.veriler[vm.indext].merchantSku);
                if (vm.ilkOkuma == 0) {
                  vm.sipariseGoreUrunListesi[vm.indext].eklenen = 1;
                  vm.eklenenToplamParca = 1;
                } else {
                  vm.sipariseGoreUrunListesi[vm.indext].eklenen = 0;
                  vm.ilkOkuma = 0;
                }
                vm.siparisToplamParca = vm.sipariseGoreUrunListesi.reduce(
                  (sum, item) => sum + item.quantity,
                  0
                );

                if (vm.eklenenToplamParca === vm.siparisToplamParca) {
                  if (vm.ekAlan1 === "hediyeMi") {
                    vm.faturaolusturControl();
                  } else {
                    if (vm.ekAlan1 === "masrafBarkodu") {
                      document.getElementById("masrafBarkodu").focus();
                    } else vm.validated = 0;
                  }
                }
              } else {
                vm.imageShow(vm.sipariseGoreUrunListesi[0].barcode);
                if (vm.ilkOkuma == 0) {
                  vm.eklenenToplamParca = 1;
                } else {
                  vm.ilkOkuma = 0;
                }
                vm.siparisToplamParca = vm.sipariseGoreUrunListesi.reduce(
                  (sum, item) => sum + item.quantity,
                  0
                );
                if (vm.eklenenToplamParca === vm.siparisToplamParca) {
                  if (vm.ekAlan1 === "hediyeMi") {
                    vm.faturaolusturControl();
                  } else {
                    if (vm.ekAlan1 === "masrafBarkodu")
                      document.getElementById("masrafBarkodu").focus();
                    else vm.validated = 0;
                  }
                }
              }
            }

            vm.barkod = "";
            vm.seriNo = "";
            if (vm.seriBarkodDurum == true) {
              if (vm.eklenenToplamParca === vm.siparisToplamParca) {
                if (vm.ekAlan1 === "hediyeMi") {
                  vm.faturaolusturControl();
                } else {
                  if (vm.ekAlan1 === "masrafBarkodu") {
                    document.getElementById("masrafBarkodu").focus();
                  } else vm.validated = 0;
                }
              } else {
                vm.seriNo = "";
                document.getElementById("barkodSeri").focus();
              }
            } else {
              if (vm.ekAlan1 !== "masrafBarkodu")
                document.getElementById("barkodM").focus();
            }
            //vm.$refs.barkod.focus()
            // vm.$nextTick(() => vm.barkod.focus())
            //vm.vSelect.barkod.focus();
          });
        });
        if (vm.ekYetkiler == "magaza") {
          setTimeout(() => {
            document.getElementById("otoBarcode").focus();
          }, 50);
        }
      } else {
        vm.indext = vm.indexbul(
          vm.sipariseGoreUrunListesi,
          (item) => item.barcode === vm.barkod || item.barcode === gelenorder.toString()
        );

        if (vm.indext == -1) {
          vm.indext1 = vm.indexbul(
            vm.sipariseGoreUrunListesi,
            (item) =>
              item.merchantSku === vm.barkod || item.merchantSku === gelenorder.toString()
          );
        }
        console.log("index " + vm.indext);

        if (vm.indext == -1) {
          vm.indext = vm.indext1;
        }
        // alert(vm.sipariseGoreUrunListesi[vm.indext].eklenen)

        if (vm.indext == -1) {
          vs.notify({
            title: "Paketleme",
            text: "Okutulan Ürün Sipariş Listesinde Yok 1",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        } else {
          vm.eklenenDeger = 0;
          console.log(gelenindex);
          if (typeof gelenindex != "undefined") {
            vm.eklenenDeger = vm.sipariseGoreUrunListesi[gelenindex].eklenen;
            if (vm.gorevlistKontrol == false)
              vm.imageShow(vm.sipariseGoreUrunListesi[gelenindex].merchantSku);
            else vm.imageShow(vm.sipariseGoreUrunListesi[0].barcode);
            if (vm.eklenenDeger == undefined) {
              vm.eklenenDeger = 0;
            }
            if (
              parseInt(vm.sipariseGoreUrunListesi[gelenindex].quantity) >
              parseInt(vm.eklenenDeger)
            ) {
              vm.sipariseGoreUrunListesi[gelenindex].eklenen =
                parseInt(vm.eklenenDeger) + 1;
              vm.eklenenToplamParca = Number(vm.eklenenToplamParca) + 1;
              if (vm.eklenenToplamParca === vm.siparisToplamParca) {
                if (vm.ekAlan1 === "hediyeMi") {
                  vm.faturaolusturControl();
                } else {
                  if (vm.ekAlan1 === "masrafBarkodu")
                    document.getElementById("masrafBarkodu").focus();
                  else vm.validated = 0;
                }
              }
              if (vm.ekYetkiler == "serilot" && vm.seriBarkodDurum == true) {
                //  vm.seriNoKaydet("EKLE", vm.veriler[0].STOCKID);
                if (vm.eklenenToplamParca === vm.siparisToplamParca) {
                  if (vm.ekAlan1 === "hediyeMi") {
                    vm.faturaolusturControl();
                  } else {
                    if (vm.ekAlan1 === "masrafBarkodu")
                      document.getElementById("masrafBarkodu").focus();
                    else vm.validated = 0;
                  }
                } else {
                  vm.seriNo = "";
                  document.getElementById("barkodSeri").focus();
                }
              }
            } else {
              vs.notify({
                title: "Paketleme",
                text: "Sipariş Adetinden Fazla Ürün Okutmayınız",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center",
              });
            }
          } else {
            vm.eklenenDeger = vm.sipariseGoreUrunListesi[vm.indext].eklenen;
            if (vm.gorevlistKontrol == false)
              vm.imageShow(vm.sipariseGoreUrunListesi[vm.indext].merchantSku);
            else vm.imageShow(vm.sipariseGoreUrunListesi[0].barcode);
            if (vm.eklenenDeger == undefined) {
              vm.eklenenDeger = 0;
            }
            if (
              parseInt(vm.sipariseGoreUrunListesi[vm.indext].quantity) >
              parseInt(vm.eklenenDeger)
            ) {
              vm.sipariseGoreUrunListesi[vm.indext].eklenen =
                parseInt(vm.eklenenDeger) + 1;
              vm.eklenenToplamParca = Number(vm.eklenenToplamParca) + 1;
              if (vm.eklenenToplamParca === vm.siparisToplamParca) {
                if (vm.ekAlan1 === "hediyeMi") {
                  vm.faturaolusturControl();
                } else {
                  if (vm.ekAlan1 === "masrafBarkodu")
                    document.getElementById("masrafBarkodu").focus();
                  else vm.validated = 0;
                }
              }
              if (vm.ekYetkiler == "serilot" && vm.seriBarkodDurum == true) {
                //    vm.seriNoKaydet("EKLE", vm.veriler[0].STOCKID);
                if (vm.eklenenToplamParca === vm.siparisToplamParca) {
                  if (vm.ekAlan1 === "hediyeMi") {
                    vm.faturaolusturControl();
                  } else {
                    if (vm.ekAlan1 === "masrafBarkodu")
                      document.getElementById("masrafBarkodu").focus();
                    else vm.validated = 0;
                  }
                } else {
                  vm.seriNo = "";
                  document.getElementById("barkodSeri").focus();
                }
              }
            } else {
              vs.notify({
                title: "Paketleme",
                text: "Sipariş Adetinden Fazla Ürün Okutmayınız",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center",
              });
            }
          }
        }

        vm.barkod = "";
        vm.seriNo = "";
        let today = new Date();
        vm.tamamlandi = today;
        if (vm.ekYetkiler == "magaza") {
          setTimeout(() => {
            document.getElementById("otoBarcode").focus();
          }, 50);
        }
      }
    },
    imageShow(sku) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { stokKodu: sku, token: Store.state.tokenId };

      soap.createClient(url, function (err, client) {
        client.resimGoruntule(args, function (err, result) {
          if (result.resimGoruntuleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.resimGoruntuleResult);
          if (vm.veriler.length > 0) {
            vm.imageLink = vm.veriler[0]["STOCKPICTURE"];
            if (vm.imageLink.includes("http")) {
              vm.imageKontrol = true;
            } else vm.imageKontrol = false;
            //   return vm.imageLink = vm.veriler[0]["STOCKPICTURE"];
          }
        });
      });
    },
    askiyaAl() {
      const vs = this.$vs;
      const vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        orderNumber: this.genelSiparisNo,
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.siparisiAskiyaAl(args, function (err, result) {
          if (result.siparisiAskiyaAlResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.siparisiAskiyaAlResult);
          vs.notify({
            title: "Paketleme",
            text: "Sipariş Askıya Alındı",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
            position: "top-center",
          });
        });
      });
    },
    stokGuncelle() {
      const vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { program: "Trendyol", token: Store.state.tokenId };
      soap.createClient(url, function (err, client) {
        client.stokAdetFiyatGuncelle(args, function (err, result) {
          if (result.stokAdetFiyatGuncelleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.stokAdetFiyatGuncelleResult);
        });
      });
    },
    tekrarIslemeAl(orderNumber, merchantSku, partiNo) {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        pazaryeri: this.pazaryeriVal.trim(),
        token: Store.state.tokenId,
        orderNumber: orderNumber,
      };
      soap.createClient(url, function (err, client) {
        client.tekrarIslemeAl(args, function (err, result) {
          if (result.siparisListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.siparisHazirla(orderNumber, merchantSku, partiNo);
          }
        });
      });
    },
    siparisHazirla(orderNumber, merchantSku, partiNo) {
      // alert(orderNumber+" "+merchantSku+" "+partiNo)
      // this.partiVal = this.selectedParti;
      this.barkod = merchantSku;
      this.orderNumberG = orderNumber;
      this.ilkOkuma = 1;
      this.barkodOku(orderNumber.trim());
      this.orderNumberMasraf = orderNumber.trim();
      this.popupActiveSiparis = false;
      this.popupGorevList = false;
    },
    morhipoToplu() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.pazaryeriVal)
      const args = { program: this.pazaryeriVal.trim() };
      soap.createClient(url, function (err, client) {
        client.MorhipoPaketlemeToplu(args, function (err, result) {
          vm.veriler = JSON.parse(result.MorhipoPaketlemeTopluResult);
        });
      });
    },
    listeTemizle() {
      this.sipariseGoreUrunListesi = [];
      this.validated = 1;
      this.eklenenToplamParca = 0;
      //    this.seriNoKaydet("SIL");
      this.genelSiparisNo = "";
      this.genelKargoAdi = "";
      this.genelKargoNo = "";
      this.genelMusteri = "";
      this.siparisNotu = "";
      this.genelToplam = "";
    },
  },

  beforeMount() {
    //setInterval(this.stokGuncelle,900000);

    var vm = this;
    //document.getElementById("barkodM").focus()
    const soap = require("soap");
    const url = state.sistemAddress;
    const args = { token: Store.state.tokenId };
    soap.createClient(url, function (err, client) {
      client.partiListesi(args, function (err, result) {
        if (result.partiListesiResult == "-1") {
          Store.dispatch("logout");
          //this.$store.dispatch('login', payload)
        }
        vm.veriler = JSON.parse(result.partiListesiResult);
        const pazaryerleri = [...new Set(vm.veriler.map((x) => x.pazaryeri))];
        vm.pazaryeriTum = vm.veriler;
        vm.options = pazaryerleri;
      });
    });
    this.columnDefsKullanici = [
      {
        headerName: "Sipariş No",
        field: "orderNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Müşteri Ad Soyad",
        field: "orderCustomer",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Kargo Firma",
        field: "kargoFirma",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Kargo Numarası",
        field: "kargoNo",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Sipariş Notu",
        field: "siparisNotu",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        width: 200,
        field: "",
        cellRendererFramework: "KullaniciGorevVermeButon",
        autoHeight: true,
      },
    ];

    this.columnDefsMasraf = [
      {
        headerName: "Sipariş No",
        field: "orderNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Stok Kodu",
        field: "stokKodu",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Tarih",
        field: "islemTarihi",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          closeOnApply: true,
        },
        cellRenderer: function (params) {
          if (params.value) {
            return moment(params.value).format("DD.MM.YYYY"); // Göstermek istediğiniz tarih formatı
          }
          return "";
        },
      },
      {
        headerName: "Adet ",
        field: "adet",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Stok Adı",
        field: "stokAdi",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },

      {
        width: 200,
        field: "",
        cellRendererFramework: "masrafButton",
        autoHeight: true,
      },
    ];

    this.columnDefs = [
      {
        headerName: "Sipariş No",
        field: "orderNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Müşteri Ad Soyad",
        sortable: true,
        filter: "agTextColumnFilter",
        valueGetter: fullNameGetter,
        field: "Column1&invoiceFirstName&shipLastName",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Mağaza Kodu",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "magazaKodu",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },

      {
        width: 100,
        field: "",
        cellRendererFramework: "FaturaCiktisiButon",
        headerName: "Tekrar Yazdır",
      },
      {
        width: 100,
        field: "",
        cellRendererFramework: "EBelgeButon",
        headerName: "E Belge",
      },
    ];
  },
};
function fullNameGetter(params) {
  if (typeof params.data.Column1 == "undefined") {
    params.data.Column1 = "";
  }
  if (typeof params.data.shipFirstName == "undefined") {
    params.data.shipFirstName = "";
  }
  if (typeof params.data.shipLastName == "undefined") {
    params.data.shipLastName = "";
  }
  return (
    params.data.Column1 + " " + params.data.shipFirstName + " " + params.data.shipLastName
  );
}
</script>
<style lang="scss">
.red-row {
  background-color: #ffcccc;
}
.con-vs-dropdown--menu {
  z-index: 420011111110;
}

.con-vs-dialog {
  z-index: 520055;
}

table.vgt-table {
  font-size: small;
}

.mb-base {
  margin-bottom: 0.75rem !important;
}

.list-view-item {
  .item-name,
  .item-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .item-name {
    -webkit-line-clamp: 2;
  }

  .item-description {
    -webkit-line-clamp: 5;
  }

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  [dir] .ag-theme-alpine .ag-overlay-loading-wrapper {
    background-color: rgba(255, 255, 255, 0.66);
    background-color: var(--ag-modal-overlay-background-color, rgba(255, 255, 255, 0.66));
    z-index: -2000;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }

  .demo-sticky-element {
    position: sticky;
    top: 10px;
    left: 10px;
    padding: 10px;
    background-color: #e3fbe1;
  }

  z-index: -1111111;
}
</style>
